import React from 'react';
import { VehicleSelect } from './VehicleSelect';
interface ComparePickerProps {
  selectedIds: string[];
  max: number;
  onSelect: (slot: number, id: string) => void;
}

/** Un desplegable por casillero: funciona igual con 5 o con 100 unidades publicadas. */
export function ComparePicker({
  selectedIds,
  max,
  onSelect
}: ComparePickerProps) {
  return <div className="mb-6 border-b border-line pb-6" data-id="element-153" data-mp="1lfiv85v1hodo">
      <p className="mb-3 text-sm text-muted" data-id="element-154" data-mp="1qfne22jf6v72">Elegí hasta {max} vehículos para comparar</p>
      <div className="grid gap-3 sm:grid-cols-3" data-id="element-155" data-mp="1uhie73pm72j9">
        {Array.from({
        length: max
      }).map((_, slot) => {
        const value = selectedIds[slot] ?? '';
        const locked = slot > selectedIds.length;
        return <div key={slot} data-id="element-156" data-mp="247lgxvmjfuus" data-mpi={slot}>
              <label htmlFor={`compare-slot-${slot}`} className="mb-1.5 block text-xs font-medium text-white" data-id="element-157" data-mp="249xu7vhcph1i">
                Vehículo {slot + 1}
              </label>
              <VehicleSelect id={`compare-slot-${slot}`} value={value} disabled={locked} excludeIds={selectedIds.filter(id => id !== value)} placeholder={locked ? 'Elegí el anterior primero' : 'Elegí un vehículo'} onChange={id => onSelect(slot, id)} data-id="element-158" data-mp="2e6sq06m8p3c3" />
            </div>;
      })}
      </div>
    </div>;
}